export const QUOTEINFO = [
  {
    title: 'Terceros Base',
    plan: 'A',
    description: 'Responsabilidad civil únicamente',
    note: '* No incluye accesorios'
  },
  {
    title: 'Terceros Completo',
    plan: 'Cm',
    description: 'Destrucción total por accidente, total y parcial por incendio y robo o hurto'
  },
  {
    title: 'Todo Riesgo',
    subtitle: 'con Franquicia',
    plan: 'D',
    description: 'Todo riesgo. Cubrimos los daños parciales superiores a la franquicia que elijas.'
  }
];
